module.exports = __webpack_public_path__ + "img/uzbekistn.ef2cba68.svg";